import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IPaginationQueryInfo } from 'types/pagination'
import { ICreateThreadMessageInput, IThreadMessages } from 'types/threads'

type GetThreadMessagesInput = IPaginationQueryInfo & { topicId: string }

export const threadMessagesApi = createApi({
  reducerPath: 'threadMessages',
  baseQuery,
  tagTypes: ['ThreadMessages'],
  endpoints: (builder) => ({
    threadMessages: builder.query<IThreadMessages, GetThreadMessagesInput>({
      query: ({ page, size, topicId }) => {
        return {
          url: `/thread-topics/${topicId}/messages`,
          method: 'get',
          params: {
            page,
            size,
          },
        }
      },
      providesTags: ['ThreadMessages'],
    }),

    createThreadMessage: builder.mutation<void, ICreateThreadMessageInput>({
      query: ({ topicId, id, messageBody, uploadedFileId }) => ({
        url: `/thread-topics/${topicId}/messages`,
        body: {
          id,
          messageBody,
          uploadedFileId,
        },
        method: 'post',
      }),
      invalidatesTags: ['ThreadMessages'],
    }),
  }),
})

export const { useThreadMessagesQuery, useCreateThreadMessageMutation } =
  threadMessagesApi
